import { useQuery } from '@tanstack/react-query';
import type { AuditLogsListResponse } from '@cms/models';
import { auditLogApi, type AuditLogsListParams } from '../api/audit-logs.api';

export function useAuditLogsPaginated(params: AuditLogsListParams = {}) {
  const { page = 1, pageSize = 25, search, sortBy, sortOrder } = params;
  return useQuery<AuditLogsListResponse>({
    queryKey: [
      'audit-logs',
      'paginated',
      page,
      pageSize,
      search ?? '',
      sortBy ?? '',
      sortOrder ?? '',
    ],
    queryFn: () =>
      auditLogApi.getPaginated({
        page,
        pageSize,
        search: search || undefined,
        sortBy,
        sortOrder,
      }),
  });
}

export function useAuditLog(id: string) {
  return useQuery({
    queryKey: ['audit-log', id],
    queryFn: () => auditLogApi.getById(id),
    enabled: !!id,
  });
}
